import { $api } from "../../../../services/request.config";
import { deleteCurrentRequestAction } from "../../CurrentRequest/deleteCurrentRequest.action";
import { getLeaderRequestsThunkAction } from "../../LeaderRequests/thunk/getLeaderRequests.thunk.action";

import IndividualCoefficientsService from "../../../../../frontend.services/LeaderRequests/IndividualCoefficientsService";

// DELETE /api/v1/managers/requests/individual-coefficients/{uid}
// Удаляет черновик заявки. Успех — 204.
// По образцу workWithCurrentRequestThunkAction: props.setState — лоадер, props.setDeleteState — текст результата
// (тот же экран DeleteRequest, что в CurrentRequestCard). Коды из swagger: 204 / 400 / 404 / 409.
export const deleteIndividualCoefficientThunkAction = (uid, props) => async (dispatch) => {
    try {
        props.setState(true);
        await $api.delete(`v1/managers/requests/individual-coefficients/${uid}`);
        props.setState(false);
        // убираем заявку из уже загруженного списка и обновляем список согласований руководителя;
        // список "Мои заявки" дополнительно перечитывается в cleanup UserRequestCard при закрытии модалки
        dispatch(deleteCurrentRequestAction(uid));
        dispatch(getLeaderRequestsThunkAction());
        return props.setDeleteState("Заявка успешно удалена");
    } catch (error) {
        props.setState(false);
        const classified = IndividualCoefficientsService.classifyError(error);
        const message = classified.message ||
            classified.details?.[0]?.message ||
            "Не удалось удалить заявку. Попробуйте позже.";
        return props.setDeleteState(message);
    }
};
